// i18n area 'networks' — locale pt-PT (pt-PT, task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/networks.pt-PT.meta.json.
import type { enUS } from './networks'

export const ptPT: typeof enUS = {
  networks: {
    common: {
      name: 'Nome',
      scope: 'Scope',
      operState: 'Estado',
      actions: 'Ações',
      create: 'Criar',
      close: 'Fechar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      save: 'Guardar',
      editError: 'Edição falhada',
      search: 'Pesquisar por nome',
      empty: 'Ainda nada por aqui',
      saveError: 'Impossível guardar',
      loadError: 'Impossível carregar — o backend TVirt está alcançável?',
      createError: 'Criação falhada',
      deleteError: 'Eliminação falhada',
      deleteConfirmTitle: 'Eliminar {name}?',
      deleteConfirmBody: 'A operação não é reversível.',
      nameHint: 'Minúsculas, dígitos e hífenes (DNS-1123)',
      up: 'Ativa',
      down: 'Inativa',
      unknown: 'Desconhecido',
      usedByVMs: 'VMs',
      emptyTable: 'Nenhuma entrada — adicione uma com o botão +'
    },
    dialogTabs: {
      general: 'Geral',
      base: 'Definição base',
      advanced: 'Configuração avançada',
      reserved: 'Ranges reservados ao TVirt',
      position: 'Posição',
      network: 'Configuração de rede',
      hosts: 'Nós participantes'
    },
    reservedRanges: {
      note: 'Estes são os ranges de IPs reservados ao TVirt, que este pode usar para atribuir automaticamente um endereço a VMs, containers, etc. NOTA: os IPs nestes ranges não devem ser usados fora do TVirt por serviços/equipamentos externos.',
      from: 'De',
      to: 'A'
    },
    overlay: {
      title: 'Redes overlay',
      createTitle: 'Criar rede overlay',
      editTitle: 'Editar rede overlay',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — atribuído automaticamente se vazio',
      subnet: 'Subnet',
      subnetHint: 'O CIDR da overlay — o IPAM deriva dele automaticamente a entrada de registo',
      mtu: 'MTU',
      weight: 'Peso',
      ceilMbps: 'Teto (Mbps)',
      fairnessHint: 'O peso só conta sob contenção: com a ligação livre cada rede pode usar toda a largura de banda. O teto, porém, aplica-se sempre.',
      contention: 'Contenção',
      contentionTip: 'Pelo menos um nó observa descartes ou overlimits COM fila na classe desta rede: a largura de banda do uplink está disputada e os pesos atuam. Quanto e desde quando estão nas séries net.shaping.* do nó.',
      firewallPolicy: 'Política de firewall',
      hosts: 'Hosts',
      hostsTitle: 'Nós participantes',
      hostsHint: 'Cada nó declara o seu endpoint underlay — um select sobre os endereços REAIS do nó, lidos da sua configuração de rede; o endereço overlay opcional deve estar dentro da subnet. A participação é a restrição de placement.',
      hostNode: 'Nó',
      hostUnderlay: 'IP underlay',
      hostUnderlayPickNode: 'Escolha primeiro o nó',
      hostAddress: 'Endereço na overlay (opcional)',
      hostAddressOutside: 'Fora da sub-rede do overlay ({cidr})',
      addHost: 'Adicionar nó',
      observedAt: 'Observado a',
      attachedNics: 'NICs ligadas'
    },
    services: {
      title: 'Serviços de rede',
      createTitle: 'Criar serviço de rede',
      editTitle: 'Editar serviço de rede',
      kind: 'Tipo',
      kindCategory: 'Serviços',
      selectKindHint: 'Escolha o tipo de serviço — o daemon subjacente é um detalhe de implementação que o TVirt gere por si.',
      kindLabel: {
        dhcp: 'Servidor DHCP',
        ntp: 'Servidor NTP',
        vpn: 'Servidor VPN',
        dns: 'Servidor DNS',
        gateway: 'Gateway',
        'lb-rp': 'Load balancer e reverse proxy',
        floatip: 'IP flutuante'
      },
      kindDesc: {
        dhcp: 'Atribui endereços nas subnets servidas — as pools derivam da subnet, do gateway e dos ranges reservados ao TVirt da rede.',
        dns: 'DNS autoritativo sobre as zonas declaradas — os records derivam do IPAM mais os seus manuais.',
        gateway: 'O nó faz de gateway para uma rede — NAT (DNAT, 1:1, SNAT/masquerade) mais routing estático entre as redes ligadas, autorreparante por design.',
        'lb-rp': 'Balanceador / proxy inverso à frente dos teus serviços — listeners L4 ou L7 sobre pools de membros ou sobre as instâncias prontas de um Pod, reconfigurados a quente.',
        ntp: 'O serviço horário das redes — relay de servidores upstream externos, ou o relógio do nó servido aos clientes.',
        vpn: 'Um concentrador VPN no nó — WireGuard ou OpenVPN, à sua escolha: acesso remoto para clientes itinerantes, ou um túnel site to site entre duas redes.',
        floatip: 'Um endereço que reside numa única instância App ou Pod saudável de cada vez e se move para o próximo alvo saudável quando este cai — failover sem daemons; o balanceamento fica com o balanceador.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'O IP flutuante vive na rede escolhida como endereço ADICIONAL dentro do namespace da instância detentora: sem portas, sem balanceamento, sem NAT — o IP do cliente permanece verdadeiro.',
        address: 'IP flutuante',
        targets: 'Alvos',
        targetsHint: 'Por ordem de PREFERÊNCIA: o primeiro alvo saudável detém o endereço. Um Pod vale por todas as suas instâncias, por réplica; cada alvo tem o seu próprio critério de saúde. Cada alvo tem de estar ligado à mesma rede.',
        targetKind: 'Alvo',
        targetApp: 'Instância App',
        targetPod: 'Pod (todas as instâncias)',
        targetRef: 'Qual',
        health: 'Saúde',
        healthRunning: 'Em execução (cada contentor pronto)',
        healthTcp: 'Ligação TCP',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Porta',
        path: 'Caminho',
        addTarget: 'Adicionar alvo',
        moveUp: 'Subir',
        moveDown: 'Descer',
        preempt: 'Preempt',
        preemptHint: 'Desligado (predefinição): um detentor saudável mantém o endereço mesmo quando um alvo superior regressa — sem oscilações. Ligado: o primeiro alvo saudável detém-no sempre.',
        holder: 'Detentor',
        noHolder: 'nenhum alvo saudável',
        since: 'desde',
        verdicts: 'Alvos observados',
        healthy: 'saudável',
        unhealthy: 'não saudável',
        noVerdict: 'Ainda não decidido — o nó autoridade escreve o primeiro veredicto na sua próxima passagem.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Esta instância detém o IP flutuante {address} do serviço {service}'
      },
      poolSource: 'Endpoints',
      poolSourceMembers: 'Membros estáticos',
      poolSourcePod: 'As instâncias prontas de um Pod',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Porta',
      poolBackendHint: 'Os endpoints seguem o Pod: uma instância entra quando corre com cada contentor pronto, sai de imediato quando é reduzida ou morre. A verificação ativa está ligada por predefinição.',
      poolBackendCount: 'as instâncias prontas do Pod {pod} na porta {port}',
      node: 'Nó',
      enabled: 'Ativado',
      parked: 'Estacionado',
      subnets: 'Subnets',
      subnetsHint: 'As subnets IPAM servidas por esta instância — as pools derivam do CIDR, do gateway e dos ranges reservados ao TVirt',
      noSubnets: 'Nenhuma subnet IPAM — declare primeiro uma rede lógica de fabric (ou uma subnet overlay): o IPAM deriva delas',
      iface: 'Interface de escuta',
      ifaceHint: 'A interface do host na qual o serviço abre o seu socket (p. ex. uma bridge) — obrigatória: um serviço de rede é autocontido, "todas as interfaces" já não existe',
      dns: 'Servidores DNS',
      domain: 'Domínio',
      detail: 'Serve',
      subnetCount: '{n} subnets',
      zones: 'Zonas',
      zonesHint: 'Só autoritativo — o daemon nunca faz recursão. Os records A derivam dos endereços declarados dos nós nas subnets IPAM referenciadas; o switch reverse serve também as zonas in-addr.arpa correspondentes (PTR). Uma zona é servida por no máximo uma instância DNS em toda a frota. O nameserver opcional é o FQDN escrito nos records NS/SOA em vez do default ns.<zona>; se cair dentro da zona, o seu record A deriva na mesma do nó servidor.',
      zoneName: 'Nome da zona',
      zoneNs: 'Nameserver (NS)',
      zoneSubnets: 'Subnets IPAM',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Records manuais',
      zoneRecordsHint: 'Um por linha: nome TIPO valor — tipos A, CNAME, MX, TXT. Numa colisão de nome vence o record manual sobre o derivado.',
      addZone: 'Adicionar zona',
      lbListeningHint: 'A instância declara UMA rede de escuta e UM endereço — cada listener liga-o na sua própria porta; um segundo endereço é um segundo serviço.',
      listeners: 'Listeners',
      listenersHint: 'Cada listener liga o endereço da instância na sua própria porta em modo L4 (passthrough TCP — os bytes nunca são abertos) ou L7 (HTTP) e encaminha para um dos pools abaixo. Um par endereço/porta é servido por no máximo uma instância por nó. As alterações aplicam-se em voo — sem reinício, sem conexões perdidas.',
      listenerName: 'Nome',
      listenerMode: 'Modo',
      modeL7: 'L7 — reverse proxy HTTP',
      modeL4: 'L4 — passthrough TCP',
      listenerPort: 'Porta',
      listenerPool: 'Pool',
      addListener: 'Adicionar listener',
      pools: 'Pools',
      poolsHint: 'Os backends onde o tráfego aterra: membros estáticos balanceados round-robin ou por menos ocupado, com um health check ativo opcional que tira da rotação os membros doentes.',
      poolName: 'Nome',
      poolAlgorithm: 'Algoritmo',
      algoRoundRobin: 'Round robin',
      algoLeastRequest: 'Menos ocupado',
      poolCheck: 'Health check',
      checkNone: 'Nenhum',
      checkTcp: 'Ligação TCP',
      checkHttp: 'HTTP',
      poolCheckPath: 'Caminho da sonda',
      poolInterval: 'Intervalo (s)',
      poolMembers: 'Membros',
      poolMembersHint: 'Um por linha: endereço:porta, opcionalmente seguido de um peso (1-128) — ex.: 10.0.0.21:8080 2',
      addPool: 'Adicionar pool',
      memberCount: '{n} membros',
      listen: {
        assignment: 'Atribuição',
        assignmentStatic: 'Endereço estático',
        assignmentAuto: 'Automática (gamas reservadas do TVirt)',
        autoHint: 'O TVirt extrai o endereço das gamas reservadas da rede lógica e mantém-no sticky — nunca re-extraído num edit ou num failover.',
        title: 'Listeners',
        hint: 'Um serviço de rede é autocontido: cada listener declara a sua rede (overlay, rede lógica de fabric ou interface bruta) e um endereço dentro da sua sub-rede — um listener por endereço, o curinga já não existe. DNS e NTP podem escutar em várias redes e vários endereços dessas redes.',
        address: 'Endereço de escuta',
        add: 'Adicionar listener'
      },
      ntp: {
        mode: 'Modo de sincronização',
        modeRelay: 'Relay de servidores externos',
        modeNodeClock: 'Relógio do nó',
        modeHint: 'O relay serve a hora tomada dos servidores upstream declarados; o relógio do nó serve a hora do nó que o aloja — que o cluster mantém sincronizada de qualquer forma',
        servers: 'Servidores upstream',
        serversHint: 'Separados por vírgula — hostname ou endereço IP; o serviço toma a hora daqui e serve-a à rede',
        port: 'Porta de escuta',
        listening: 'À escuta em'
      },
      vpn: {
        engine: 'Motor',
        engineHint: 'É você que o escolhe, e não muda mais: o WireGuard é moderno, rápido e no kernel; o OpenVPN é o veterano da compatibilidade (TCP, redes hostis)',
        engineLocked: 'O motor é imutável — outro motor é um serviço novo, as suas chaves e certificados não são portáveis',
        mode: 'Modo',
        modeRemote: 'Acesso remoto',
        modeSite: 'Site to site',
        modeHint: 'O acesso remoto dá aos clientes itinerantes um endereço no túnel; o site to site une duas redes',
        port: 'Porta de escuta',
        protocol: 'Transporte',
        protocolWireguardHint: 'O WireGuard só fala UDP',
        tunnelSubnet: 'Subnet do túnel',
        tunnelSubnetHint: 'A rede onde vivem os clientes — registada no registo IPAM, nasce e morre com este serviço',
        dnsServers: 'DNS empurrados aos clientes',
        routes: 'Rotas empurradas aos clientes',
        routesHint: 'Redes separadas por vírgulas alcançáveis pelo túnel; a subnet do túnel está sempre incluída',
        peers: 'Peers',
        peersHint: 'Deixe a chave pública vazia e o TVirt gera o par — depois entrega-o com o perfil. Cole uma chave e o peer mantém a sua.',
        clients: 'Clientes',
        clientsHint: 'Cada cliente recebe um certificado emitido pela CA própria deste serviço. Retirar um cliente REVOGA-O: a CRL é regenerada de imediato.',
        peerName: 'Nome',
        publicKey: 'Chave pública',
        publicKeyMinted: 'É o TVirt que a gera',
        peerAddress: 'Endereço no túnel',
        peerAddressHint: 'Vazio = atribuído',
        allowedIps: 'Subnets remotas',
        allowedIpsHint: 'Separadas por vírgulas, encaminhadas através deste peer',
        endpoint: 'Endpoint',
        presharedKey: 'Chave pré-partilhada',
        keepalive: 'Keepalive (s)',
        addPeer: 'Adicionar peer',
        addClient: 'Adicionar cliente',
        auth: 'Autenticação',
        authTls: 'Certificados (TLS)',
        remote: 'Endpoint remoto',
        remoteHint: 'host:porta da ponta remota — vazio significa que este lado espera',
        peerRoutes: 'Subnets remotas',
        serverPublicKey: 'Chave pública deste servidor',
        ca: 'Autoridade de certificação',
        listening: 'À escuta em',
        tunnel: 'Túnel',
        peerCount: '{n} peers',
        download: 'Descarregar perfil',
        downloadError: 'Não foi possível exportar o perfil',
        lastHandshake: 'Último handshake',
        never: 'nunca',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Ligado',
        idle: 'Inativo'
      },
      gateway: {
        attach: 'Tipo de rede de listening',
        attachOverlay: 'Rede overlay',
        attachNetwork: 'Rede lógica de fabric',
        attachInterface: 'Interface crua',
        overlay: 'Rede overlay',
        network: 'Rede lógica',
        interface: 'Nome da interface',
        interfaceHint: 'Uma interface do host que o TVirt não gere — o endereço é dado por bom',
        address: 'Endereço de listening (gateway)',
        addressHint: 'O endereço gateway para o qual os clientes apontam — dentro da subnet da rede de listening',
        dnatTitle: 'Regras DNAT',
        dnatHint: 'NAT de destino: o tráfego do match é redirecionado para um novo endereço (e opcionalmente uma nova porta). Qualquer protocolo da lista — as portas onde o protocolo as leva.',
        snatTitle: 'Regras SNAT',
        snatHint: 'NAT de origem: o tráfego do match sai com a origem reescrita — um novo endereço explícito (e opcionalmente uma nova porta), ou masquerade no endereço de saída se ficar vazio.',
        oneToOneTitle: 'Regras 1:1 NAT',
        oneToOneHint: 'Cada pacote para o endereço externo mapeia no interno, e o host interno sai como o externo — todos os protocolos, ambos os sentidos.',
        external: 'Endereço externo',
        internal: 'Endereço interno',
        addOneToOne: 'Adicionar regra 1:1',
        family: 'Família',
        protocol: 'Protocolo',
        source: 'Origem (endereço/subnet)',
        destination: 'Destino (endereço/subnet)',
        invert: 'NOT',
        srcPorts: 'Portas de origem',
        dstPorts: 'Portas dest.',
        dstPortsHint: 'Porta ou intervalo (80, 8000-8099)',
        toAddress: 'Novo endereço',
        toPort: 'Nova porta',
        snatTo: 'Nova origem (vazia = masquerade)',
        snatToHint: 'Endereço de origem explícito; vazio = masquerade no endereço de saída',
        addDnat: 'Adicionar regra DNAT',
        addSnat: 'Adicionar regra SNAT',
        routesTitle: 'Rotas estáticas',
        routesHint: 'O nó encaminha entre as redes a que está ligado (o IP forwarding está ativo); estas rotas acrescentam alcance para além delas — kernel puro, o encaminhamento dinâmico chega com uma ronda posterior.',
        routeDestination: 'Subnet de destino',
        routeGateway: 'Next hop',
        routeMetric: 'Métrica',
        addRoute: 'Adicionar rota',
        listening: 'À escuta em',
        rules: '{d} DNAT · {o} 1:1 · {s} SNAT · {r} rotas'
      },
      unknownSince: 'Desconhecido — último report há {m} min',
      lastWord: 'Última palavra',
      reportObservedAt: 'Último report',
      lastErrorRow: 'Último erro',
      recordsCount: '{n} records manuais',
      phase: {
        configured: 'Configurado',
        running: 'Em execução',
        error: 'Erro'
      },
      authorityNode: 'Authority (atribuição)',
      preferredNode: 'Nó preferido',
      preferredNodeHint: 'Uma preferência suave, nunca uma restrição: na próxima decisão de colocação a instância aterra aqui se o membro for elegível — por si só não move nada; o movimento é "Transferir authority".',
      noPreference: 'Sem preferência (colocação automática)',
      moving: 'Em movimento',
      movingTooltip: 'Observado aqui enquanto a authority atribui {node}: o movimento está a convergir.',
      placement: {
        title: 'Colocação',
        loading: 'Censo em curso…',
        loadError: 'O censo de colocação não respondeu — tente novamente mais tarde.',
        draftHint: 'O censo calcula-se sobre a ligação de rede declarada: aparecerá com o serviço criado. A criação é recusada se nenhum membro o puder servir, e a recusa nomeia o mecanismo que esvaziou o conjunto.',
        eligibleCount: '{n} de {m} membros podem servir esta instância',
        recommended: 'Recomendado',
        eligible: 'Elegível',
        notEligible: 'Não elegível',
        blockedReachability: 'a rede não chega a este membro',
        blockedRequireTag: 'bloqueado por uma tag obrigatória (requireNodes)',
        blockedExcluded: 'excluído pela simulação',
        preferenceUnknown: 'não é (ou já não é) membro do cluster',
        preferenceIgnored: 'A preferência "{node}" hoje não é elegível: {reason}. Prevalece a recomendação do censo — nunca um erro, o serviço vive noutro lugar.',
        emptyReachability: 'Nenhum membro pode servir esta instância: a rede não chega a lado nenhum — nenhum retoque nas tags ajudará. Ligue o nó por cabo, ou mova o serviço para onde a rede está.',
        emptyRequireTag: 'Nenhum membro pode servir esta instância: foram as tags obrigatórias que esvaziaram o conjunto — retire a entrada de requireNodes, ou atribua a tag a um membro.',
        spof: 'Ponto único de falha',
        spofDetail: 'Um só membro pode alojar a instância: na falha, o failover não tem para onde ir. Um serviço multi-listener move-se como UNIDADE — o candidato tem de ver TODAS as suas redes: é esse o custo.',
        whatIf: 'Simular membros ausentes',
        whatIfHint: 'O what-if do drain: pergunte ANTES da evacuação, não o descubra no failover.',
        survives: 'Com {nodes} ausente(s), o serviço ainda tem uma casa.',
        notSurvives: 'Evacuar {nodes} deixa este serviço EM BAIXO: a restrição derivada vence a disponibilidade (R30) — um daemon vivo onde a rede não chega não serve ninguém e não alarma ninguém.',
        transfer: 'Transferir authority',
        transferError: 'A transferência falhou',
        transferTarget: 'Membro de destino',
        transferHint: 'Só os membros elegíveis são propostos — uma preferência dentro do conjunto válido, nunca um override. Nenhuma task: o próximo passo dos workers É o movimento (o nó velho ceifa, o novo ergue).'
      }
    },
    fabric: {
      tabDerivation: 'Derivação',
      importNetwork: 'Importar de outra fabric',
      importTitle: 'Importar uma rede lógica',
      importHint: 'A importação é a adesão explícita: a rede continua a ser do titular (mesma identidade, mesmo stem, mesma bridge tvf-<stem>) e daqui mapeia-se nas portas/LAGG desta fabric — mapear É afirmar que a entrega desemboca no mesmo domínio L2 que a do titular.',
      importPick: 'Rede do titular',
      importNone: 'Nada a importar: as outras fabrics não têm nenhuma rede própria que esta fabric não conheça já',
      importedNetworksTitle: 'Redes importadas',
      noImported: 'Nenhuma rede importada',
      importedFrom: 'importada de {fabric}',
      importedBy: 'Importada por: {list}',
      importedCount: '+{n} importadas',
      owner: 'Titular',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Remover a importação',
      unimportConfirm: 'Remover a importação da rede {name} (titular {fabric}) desta fabric? É recusado enquanto uma porta ou LAGG desta fabric a mapear, ou um guest, App ou serviço for servido só através desta perna.',
      unimportRefused: 'Importação ainda em uso — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Este nó já recebe essa rede de outra fabric de que é membro: um nó recebe uma rede partilhada por UMA só das suas pernas (dois uplinks do mesmo L2 numa bridge sem STP são um ciclo). Desmapeia-a nas portas ou no LAGG de uma das duas fabrics.',
          otherFabricDerived: 'O documento traz o bloco de uma fabric para a qual o nó já não declara nenhum cabo: aplica primeiro o plano dessa fabric (propõe a remoção dos seus dispositivos), ou toma posse deles com take-ownership se a fabric já não existir.'
        },
        hint: 'O plano de derivação O.3: para cada nó cablado o estado, o diff derivado-vs-atual, a topologia de bond DECLARADA, os flips dual-stack e as recusas/avisos estruturados. Só leitura até ao apply EXPLÍCITO — nada aterra sozinho num nó.',
        refresh: 'Recarregar o plano',
        empty: 'Nenhum nó está cablado a esta fabric (e nenhum ainda carrega o seu bloco).',
        refusal: 'Recusa',
        warning: 'Aviso',
        generation: 'geração do documento {n}',
        state: {
          manual: 'Manual',
          derived: 'Derivado',
          diverged: 'Divergente'
        },
        topologyTitle: 'Topologia declarada',
        members: 'membros',
        primary: 'primária',
        held: 'retido num SÓ membro',
        form: {
          perNetworkBond: 'Bond por rede',
          singleBond: 'Bond único de recurso',
          laggBond: 'Bond LACP (LAGG)',
          singlePort: 'Porta única'
        },
        colAction: 'Ação',
        colKind: 'Tipo',
        colDevice: 'Device',
        colDetail: 'Detalhe',
        action: {
          add: 'adicionar',
          remove: 'remover',
          replace: 'substituir'
        },
        diffEmpty: 'Nenhum diff pendente — o documento aplicado coincide com o render.',
        diffBlocked: 'Nenhum diff: as recusas acima bloqueiam este nó.',
        phasePlanned: 'planeado (passo 1 de 3)',
        phaseDraining: 'em drenagem (passo 2 de 3)',
        probeUnobserved: 'Sonda de drenagem: nunca reportada — o vazio é DESCONHECIDO (um retiro agora seria recusado).',
        probeFailed: 'Sonda de drenagem: observação FALHADA — os timestamps conhecidos arrastam-se, nunca um «vazio» que ninguém mediu.',
        probeActive: {
          one: 'Sonda: {n} ligação estabelecida ainda no endereço velho',
          many: 'Sonda: {n} ligações estabelecidas ainda no endereço velho',
          other: 'Sonda: {n} ligações estabelecidas ainda no endereço velho'
        },
        probeLastActive: 'última atividade {time}',
        probeEmpty: {
          one: 'Sonda: vazio há {n} minuto',
          many: 'Sonda: vazio há {n} minutos',
          other: 'Sonda: vazio há {n} minutos'
        },
        probeEmptyUnknown: 'Sonda: vazio (desde quando, desconhecido).',
        impact: '{nics} vNIC e {apps} App neste nó usam estas redes: {list}',
        apply: 'Aplicar neste nó',
        applyTitle: 'Aplicar a derivação — {node}',
        applyIntro: 'A configuração derivada reescreve o documento de rede de {node} ({n} alterações) pela mesma porta do editor host-network — checkpoint do NetworkManager e probe honesta incluídos. Os avisos do plano abaixo viajam com o ato: leia-os antes de confirmar.',
        applyError: 'Apply falhado',
        applyRefused: 'O nó recusou:',
        planMoved: 'A fabric mudou depois desta pré-visualização — NADA foi aplicado. O plano foi recarregado: olhe de novo e tente outra vez.',
        retire: 'Retirar',
        retireTitle: 'Ponto de não retorno — retiro de {address}',
        restore: 'Restaurar',
        restoreTip: 'De volta ao snapshot anterior ao apply (geração {previous}) — o desfazer de um passo (H13)',
        restoreTitle: 'Restaurar o documento anterior — {node}',
        restoreIntro: 'O documento de rede de {node} volta ao snapshot tirado antes do último apply (geração {previous}), reescrito como geração {next} no lugar da {current}. O worker converge-o como qualquer outro documento.',
        restoreRedo: 'O documento substituído passa a ser o novo snapshot: restaurar de novo é o refazer.',
        restoreClosesChain: 'O snapshot é o documento manual anterior à derivação: a cadeia fecha-se aqui — sem mais desfazer, o nó fica manual até ao próximo apply.',
        restoreConfirm: 'Restaurar',
        restoreError: 'Restauro falhado',
        retireIntro: 'Isto remove {address} ({network}) de {point} definitivamente. Depois deste ato o caminho de volta é o flip INVERSO — redeclarar o endereço velho pelo mesmo motor — nunca um restauro cego.',
        retireOld: 'Endereço velho (removido)',
        retireNew: 'Endereço novo (fica)',
        retireEmptyFact: 'A sonda dá o endereço vazio: este retiro não corta nenhuma ligação observada.',
        retireConfirm: 'Retirar o endereço',
        severActiveLoss: {
          one: 'Cortar {n} ligação estabelecida ainda no endereço velho — morre com este ato',
          many: 'Cortar {n} ligações estabelecidas ainda no endereço velho — morrem com este ato',
          other: 'Cortar {n} ligações estabelecidas ainda no endereço velho — morrem com este ato'
        },
        severUnknownLoss: 'Aceitar o DESCONHECIDO: a sonda nunca observou este endereço (ou a observação falha) — ligações vivas podem ser cortadas.'
      },
      title: 'Fabric',
      createTitle: 'Criar fabric',
      networks: 'Redes',
      switches: 'Switches',
      ports: 'Portas',
      laggs: 'LAGGs',
      subnets: 'Subnets',
      tabOverview: 'Visão geral',
      tabNetworks: 'Redes lógicas',
      tabSwitches: 'Switches',
      overviewHint: 'A fabric num relance: cada rede lógica com MTU e subnet (as VLANs vivem só nos mapeamentos por porta/por LAGG — a mesma rede pode viajar com tags diferentes em portas diferentes). A fabric é o registo de uma infraestrutura EXTERNA — o TVirt observa e declara, nunca faz provisioning, e só toca nas NICs registadas sob o seu controlo.',
      absorptionHint: 'Cada subnet declarada aqui DERIVA a sua entrada no registo IPAM na mesma escrita — vive e morre com a rede.',
      scopeFixedHint: 'O scope é fixo na raiz do cluster: a infraestrutura física é, por definição, de todo o cluster.',
      networksHint: 'Cada rede traz um MTU obrigatório (default 1500) e uma subnet obrigatória; gateway, servidores DNS e rotas estáticas declarados aqui são a FONTE ÚNICA para as NICs dos servidores, as Apps e os serviços de rede.',
      switchesHint: 'O registo manual: uma porta está não usada, mapeada (tráfego untagged e por VLAN tag nas redes lógicas) ou é membro de um LAGG — um membro não traz mapeamentos próprios.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Obrigatório — o IPAM deriva dele automaticamente a entrada de registo',
      nodeAddressing: 'Endereçamento de nós',
      nodeAddressingNone: 'Nenhum — sem endereço por nó',
      nodeAddressingPool: 'Pool — um endereço fixo por nó servido',
      nodeAddressingHint: 'Com Pool, a derivação do fabric atribui a cada nó servido um endereço dos intervalos reservados ao TVirt (fixo depois de atribuído).',
      backing: 'Backing',
      gateway: 'Gateway',
      ranges: 'Ranges reservados',
      dns: 'Servidores DNS (separados por vírgula)',
      dnsShort: 'DNS',
      singleSourceHint: 'Gateway, DNS e rotas declarados aqui são a fonte única — as NICs dos servidores, as Apps e os serviços de rede vão buscar aqui',
      routesTitle: 'Rotas estáticas',
      routeDestination: 'Destino (CIDR)',
      routeVia: 'Via (next hop)',
      portUsed: 'Usada',
      vlanMappings: 'Mapeamentos VLAN',
      vlanTag: 'Tag VLAN',
      vlanNetwork: 'Rede lógica',
      nameTaken: 'Nome já usado na fabric',
      addNetwork: 'Adicionar rede',
      editNetwork: 'Editar rede',
      deleteNetwork: 'Remover rede',
      deleteNetworkConfirm: 'Remover a rede lógica {name} da fabric? A sua subnet derivada no IPAM morre com ela (recusado enquanto um serviço ou uma App a usar). Os mapeamentos de portas e LAGG que a referenciam são limpos.',
      switchName: 'Switch',
      portName: 'Porta',
      positionHint: 'Posição física (opcional) — o mesmo vocabulário do posicionamento dos servidores; só declarativa',
      addSwitch: 'Adicionar switch',
      editSwitch: 'Editar switch',
      deleteSwitch: 'Remover switch',
      deleteSwitchConfirm: 'Remover o switch {name} com todas as suas portas? Os LAGGs encolhem em conformidade (e morrem abaixo de duas portas).',
      addPort: 'Adicionar porta',
      editPort: 'Editar porta',
      deletePort: 'Remover porta',
      deletePortConfirm: 'Remover a porta {name}?',
      untagged: 'Untagged',
      tagged: 'Tagged (tag:rede)',
      taggedShort: 'Tagged',
      portCabling: 'Cablagem',
      portState: 'Estado',
      stateUnused: 'não usada',
      stateMapped: 'mapeada',
      laggPortGuard: 'Uma porta membro de um LAGG edita-se do lado do LAGG',
      laggsTitle: 'LAGGs',
      laggsHint: 'Um LAGG são 2+ portas em LACP e pode atravessar switches (MLAG, transparente); só entram portas não usadas, o LAGG é a superfície de mapeamento, uma porta removida volta a não usada.',
      addLagg: 'Adicionar LAGG',
      editLagg: 'Editar LAGG',
      deleteLagg: 'Remover LAGG',
      deleteLaggConfirm: 'Remover o LAGG {name}? As suas portas membros voltam a não usadas.',
      lacpRate: 'Rate LACP',
      laggPorts: 'Portas membros (2+)',
      laggPortsHint: 'Só entram portas não usadas — liberte primeiro uma porta mapeada',
      noNetworks: 'Nenhuma rede lógica declarada.',
      noSwitches: 'Nenhum switch declarado.',
      noLaggs: 'Nenhum LAGG declarado.',
      staleConflict: 'Outro operador alterou esta fabric enquanto a estavas a editar: a gravação foi recusada para não apagar o trabalho dele. As tuas alterações continuam aqui, intactas. A fabric atualizada já foi recarregada: confirma de novo para as reaplicares por cima, ou cancela e vê o que mudou.'
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Só derivado: cada subnet nasce de uma rede lógica de fabric ou de uma overlay — edita-se na origem. Os endereços atribuídos mostram QUEM os detém; os ranges reservados ao TVirt são as pools da atribuição automática.',
      search: 'Pesquisar por nome, CIDR ou endereço',
      empty: 'Nenhuma rede — declare uma rede lógica de fabric ou uma subnet overlay: o IPAM deriva delas automaticamente.',
      reserved: 'Ranges reservados ao TVirt',
      address: 'Endereço',
      origin: 'Origem',
      origin_declared: 'declarado',
      origin_observed: 'observado',
      holder: 'Detido por',
      noAddresses: 'Nenhum endereço conhecido nesta subnet.',
      sourceFabric: 'Fabric',
      sourceOverlay: 'Overlay',
      editAtSource: 'Editar na origem'
    },
    firewall: {
      title: 'Grupos de firewall',
      createTitle: 'Novo grupo de firewall',
      editTitle: 'Editar grupo de firewall',
      empty: 'Nenhum grupo de firewall — crie um: um vocabulário de regras reutilizável, referenciado pelas NICs de convidado pelo nome.',
      nameHint: 'Letras, algarismos e . - _ interiores; único dentro do seu scope (os homónimos noutros sítios distinguem-se com /scope/nome)',
      description: 'Descrição',
      descriptionHint: 'Uma linha de intenção, mostrada onde quer que o grupo se escolha',
      enforced: 'Imposto ao scope',
      enforcedHint: 'Desligado: vocabulário puro — as regras vinculam só as NICs que referenciam o grupo. Ligado: as regras vinculam cada NIC de convidado com a firewall ligada sob o scope do grupo, referenciadas ou não.',
      enforcedChip: 'Imposto',
      enforcedChipHint: 'As regras vinculam cada NIC de convidado com a firewall ligada sob o scope do grupo, referenciadas ou não',
      enforceWarning: 'Ao ativar a imposição as regras vinculam CADA NIC de convidado com a firewall ligada sob {scope} no próximo alinhamento, mesmo sem referência explícita — e dentro de uma chain ativa o drop de um antepassado é definitivo: os níveis abaixo não o reabrem.',
      unenforceInfo: 'Ao retirar a imposição as regras ficam só nas NICs que referenciam o grupo explicitamente.',
      rules: 'Regras',
      tabOverview: 'Visão geral',
      tabRules: 'Regras',
      orderHint: 'A ordem das linhas É a ordem de avaliação dentro do grupo: vence a primeira regra que coincide.',
      statefulHint: 'O stateful é implícito: as respostas ao tráfego admitido passam sozinhas (established/related aceites, invalid descartado — injeta-as o motor, não se escrevem à mão).',
      noRules: 'Nenhuma regra — um vocabulário em construção: referenciá-lo é lícito e não renderiza nada.',
      addRule: 'Adicionar regra',
      direction: 'Direção',
      directionIn: 'Entrada',
      directionOut: 'Saída',
      action: 'Ação',
      action_accept: 'Aceitar',
      action_drop: 'Descartar',
      action_reject: 'Rejeitar',
      protocol: 'Protocolo',
      protocolAny: 'Qualquer',
      ports: 'Portas',
      source: 'Origem',
      dest: 'Destino',
      comment: 'Comentário',
      addressHint: 'CIDR IPv4 ou <fabric>/<rede lógica>; vazio = qualquer',
      moveUp: 'Mover para cima',
      moveDown: 'Mover para baixo',
      nicFirewall: 'Firewall',
      nicAntiSpoof: 'Anti-spoofing',
      nicGroups: 'Grupos de firewall',
      nicGroupsPlaceholder: 'Escolha um grupo…',
      nicGroupsHint: 'Os grupos visíveis, incluindo os dos scopes superiores (utilizáveis para baixo, como as tags)',
      nicGroupCount: { one: '{n} grupo de firewall', many: '{n} grupos de firewall', other: '{n} grupos de firewall' },
      nicOff: 'Firewall desligado',
      pendingRestartHint: 'As alterações de firewall seguem o modelo guardado/aplicado: esperam pelo próximo power cycle (PendingRestart). Os grupos impostos pelos scopes superiores aplicam-se quando a firewall da NIC está ligada.',
      appConvergeHint: 'As alterações de firewall aplicam-se no próximo alinhamento do container. Os grupos impostos pelos scopes superiores aplicam-se quando a firewall está ligada.',
      enforcedAncestors: 'Impostos pelos scopes superiores',
      enforcedAncestorsHint: 'Este grupo aplica-se a cada NIC sob o seu scope com a firewall LIGADA — o toggle é o interruptor geral da NIC (desligada = nenhuma chain, antepassados incluídos); dentro de uma chain ativa a autoridade do antepassado é definitiva: o seu drop não se reabre abaixo.'
    }
  }
}
